(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["miir-wide-mouth-editorial"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-miir-back-to-top]');
  if (!link) return;
  event.preventDefault();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: 0, left: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
});

document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input.matches('[data-miir-editorial-variant]')) return;
  var section = input.closest('.miir-editorial');
  if (!section) return;
  var form = input.closest('form');
  var variantSelect = form && form.querySelector('[data-miir-variant-id]');
  if (variantSelect && variantSelect.value !== input.value) {
    variantSelect.value = input.value;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var color = section.querySelector('[data-miir-selected-color]');
  if (color) color.textContent = input.dataset.color || '';
  var image = section.querySelector('.miir-editorial__hero-image img');
  if (image && input.dataset.image) {
    image.removeAttribute('srcset');
    image.src = input.dataset.image;
    image.alt = 'MiiR Wide Mouth Bottle 32oz สี ' + (input.dataset.color || '');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origami-matcha-v1"] && !Shopify.designMode) return;
  try {
    
function initOrigami(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const cards = [...root.querySelectorAll('.colour-card')];
  const select = root.querySelector('#origami-variant');
  const add = root.querySelector('#origami-add');
  function choose(card) {
    if (!card) return;
    cards.forEach(item => { const active = item === card; item.classList.toggle('selected', active); item.querySelector('input').checked = active; });
    root.querySelector('#selected-colour').textContent = card.dataset.title;
    root.querySelector('.selection-price strong').textContent = card.dataset.price;
    root.querySelector('.selection-price del').textContent = card.dataset.compare;
    if (select) select.value = card.dataset.variant;
    if (add) { const available = card.dataset.available === 'true'; add.disabled = !available; add.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel; root.querySelector('.stock-status').textContent = available ? '' : root.dataset.soldLabel; }
  }
  cards.forEach(card => card.querySelector('input').addEventListener('change', () => { choose(card); if (typeof renderLanguage === 'function') renderLanguage(activeLanguage); }));
  if (select) select.addEventListener('change', () => { choose(cards.find(card => card.dataset.variant === select.value)); if (typeof renderLanguage === 'function') renderLanguage(activeLanguage); });
  choose(cards.find(card => card.querySelector('input').checked));
  const translations = JSON.parse(root.querySelector('.origami-translation-map').textContent);
  const normalize = value => value.replace(/\s+/g, ' ').trim();
  const textNodes = [];
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode;
    if (node.parentElement.closest('script, style')) continue;
    const original = node.nodeValue;
    const translated = translations[normalize(original)];
    if (translated) textNodes.push({ node, original, translated });
  }
  const attributes = [];
  root.querySelectorAll('[alt], [aria-label], [title], [placeholder]').forEach(element => {
    for (const name of ['alt', 'aria-label', 'title', 'placeholder']) {
      const original = element.getAttribute(name);
      if (original && translations[normalize(original)]) attributes.push({ element, name, original, translated: translations[normalize(original)] });
    }
  });
  const languageButtons = [...root.querySelectorAll('.language-switch button')];
  let activeLanguage = 'en';
  function renderLanguage(language) {
    activeLanguage = language;
    textNodes.forEach(({ node, original, translated }) => {
      const lead = original.match(/^\s*/)[0], trail = original.match(/\s*$/)[0];
      node.nodeValue = language === 'th' ? lead + translated + trail : original;
    });
    attributes.forEach(({ element, name, original, translated }) => element.setAttribute(name, language === 'th' ? translated : original));
    root.dataset.addLabel = language === 'th' ? translations['Add to cart'] : 'Add to cart';
    root.dataset.soldLabel = language === 'th' ? translations['Sold out'] : 'Sold out';
    if (add) {
      const selected = cards.find(card => card.querySelector('input').checked);
      const available = selected?.dataset.available === 'true';
      add.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
      root.querySelector('.stock-status').textContent = available ? '' : root.dataset.soldLabel;
    }
    languageButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lang === language)));
    document.documentElement.lang = language;
    try { sessionStorage.setItem('origami-v1-language', language); } catch {}
  }
  languageButtons.forEach(button => button.addEventListener('click', () => renderLanguage(button.dataset.lang)));
  let savedLanguage = 'en';
  try { if (sessionStorage.getItem('origami-v1-language') === 'th') savedLanguage = 'th'; } catch {}
  renderLanguage(savedLanguage);
  const video = root.querySelector('#ritual-video');
  root.querySelector('#play-video').addEventListener('click', async () => { video.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); try { await video.play(); } catch { root.querySelector('#video-error').hidden = false; } });
  video.addEventListener('error', () => { root.querySelector('#video-error').hidden = false; });
  const sticky = root.querySelector('.sticky-buy');
  const observer = new IntersectionObserver(entries => sticky.classList.toggle('visible', !entries[0].isIntersecting));
  observer.observe(root.querySelector('.hero'));
  root.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
}
document.querySelectorAll('.origami-campaign').forEach(initOrigami);
document.addEventListener('shopify:section:load', event => initOrigami(event.target.querySelector('.origami-campaign')));


  } catch(e) { console.error(e); }
})();
})();
